import * as React from 'react';
import { SVGProps } from 'react';

const IconLaptopFilledSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h5-7v2h16v-2H9h5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2Zm11 2H3v6h10V4Z"
    />
  </svg>
);
export default IconLaptopFilledSizeS;
